// @flow

// Based on the hover state, determine content visibility state. Content
// visibility is a tri-state instead of just visible or not because we want to
// fade content out before removing and in before fully visible.

import type { TransitionState } from 'app/common/react/components/PinRep/Hooks/useTransitionManager';

export type ContentVisibility = 'none' | 'hidden' | 'visible';

export function getVisibilityFromTransitionState(state: TransitionState): ContentVisibility {
  if (state === 'active') {
    return 'visible';
  }

  if (state === 'inactive') {
    return 'none';
  }

  return 'hidden';
}

export function reverseVisibility(visibility: ContentVisibility) {
  if (visibility === 'none') {
    return 'visible';
  }

  if (visibility === 'visible') {
    return 'none';
  }

  return 'hidden';
}

export function getLowestVisibility(...visibilities: Array<ContentVisibility>) {
  if (visibilities.includes('none')) {
    return 'none';
  }

  if (visibilities.includes('hidden')) {
    return 'hidden';
  }

  return 'visible';
}

export function getHighestVisibility(...visibilities: Array<ContentVisibility>) {
  if (visibilities.includes('visible')) {
    return 'visible';
  }

  if (visibilities.includes('hidden')) {
    return 'hidden';
  }

  return 'none';
}
